import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Actions
import {
    removeFinalFormUnsavedValues
    // @ts-ignore
} from 'services/finalFormsUnsavedValues/actions';

// Selectors
import {
    makeSelectTimesheetValue
    // @ts-ignore
} from 'services/timesheet/selectors';

interface IOwnProps {}

interface IStateProps {
    timesheetId?: number;
    isApproved?: boolean;
}

interface IDispatchProps {
    removeFinalFormUnsavedValues: Function;
}

export interface IProps extends IOwnProps, IStateProps, IDispatchProps {}

export class TimesheetAutoDiscardUnsavedValues extends React.PureComponent<
    IProps
> {
    componentDidMount() {
        const { timesheetId, isApproved } = this.props;
        if (isApproved) {
            this.props.removeFinalFormUnsavedValues(
                `TimesheetTimesheetEntriesForm.${timesheetId}`
            );
        }
    }

    componentDidUpdate(prevProps: IProps) {
        const { timesheetId, isApproved } = this.props;

        if (!prevProps.isApproved && isApproved) {
            this.props.removeFinalFormUnsavedValues(
                `TimesheetTimesheetEntriesForm.${timesheetId}`
            );
        }
    }

    render() {
        return null;
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    timesheetId: makeSelectTimesheetValue('id'),
    isApproved: makeSelectTimesheetValue('isApproved')
});

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    { removeFinalFormUnsavedValues }
)(TimesheetAutoDiscardUnsavedValues);
